import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { Page } from '../../components';
import { UserContext } from '../../context';

export const NoRoles = () => {
  const { isLoading } = useContext(UserContext);
  if (isLoading) {
    return null;
  }

  return (
    <Page title="No Roles" showSideNav={false} showSettings={false} showNews={false}>
      <Stack justifyContent="center" alignItems="center" gap={1} height="35rem">
        <Typography component="h1" variant="h3">
          No Roles Found
        </Typography>
        <Typography component="p" variant="body1">
          User does not have any roles assigned! Please have Admin assign roles and then try to
          login again.
        </Typography>
      </Stack>
    </Page>
  );
};
